import { useMeteoData } from './Hooks/useMeteoData';
import Chart from './components/Chart';
import Alerts from './components/Alerts';
import config from "./config.json";
import { data2series } from "./utils/functions";

const time_range = "PT48H";


// Lee settings del storage; si no hay, usa los valores de config.json
const appSettings = JSON.parse(localStorage.getItem('appSettings')) || {};
const stations = appSettings.stations || config.stations;
const sensors = config.sensors

function Plots() {

  // Hook para datos meteorológicos
  const { data, loading, error, refetch } = useMeteoData(stations, time_range);

  const series = data2series(data, stations, sensors);

  // Mostrar loading spinner o error si es necesario
  if (loading) {
    return <Alerts loading={loading} /> 
  } 

  return (
    <div className="">
   
      {/* ---- Graficos ------ */}


      <h2 className='h5 ml-3'>Last 48 hours</h2>

      <div className="mt-5">
          <Chart
              title="Humidity"
              seriesName="Humidity (%RH)"
              data={series.humidity}
              yAxisLabel="%RH"
              color="#d0e2b3"
              limits={{'soft': false, 'hard': config.limits.humidity.hard}}
              ylim={[0, 100]}
              tickInterval={25}
              height={350}
          />
          <Chart
              title="Wind Speed"
              seriesName="Wind Speed (m/s)"
              data={series.wind_speed}
              limits={{'soft': false, 'hard': config.limits.wind_speed.hard}}
              yAxisLabel="m/s"
              tickInterval={5}
              height={350}
            />
            <Chart
                title="Dust"
                seriesName="Dust"
                data={series.dust}
                limits={{'soft': false, 'hard': config.limits.dust.hard }}
                yAxisLabel="m⁻³"
                ylim={[0, null]}
                tickInterval={0.001}
                height={350}
            />
          <Chart
              title="Temperature"
              seriesName="Temperature (°C)"
              data={series.temperature}
              yAxisLabel="°C"
              color="aqua"
              tickInterval={5}
              height={350}
          />
            <Chart
                title="Pressure"
                seriesName="Pressure"
                data={series.pressure}
                yAxisLabel="mbar"
                ylim={[750, 800]}
                tickInterval={10}
                height={350}
            />
            <Chart
                title="Seeing"
                seriesName="Seeing"
                data={series.seeing}
                yAxisLabel="arcsec"
                ylim={[0, 15]}
                tickInterval={1}
                height={350}
            />
      </div>
    </div>
  );
}

export default Plots;
